import { useAppText } from "src/commun/composants/AppText";
import { regexLength, regexLowerCaseLetter, regexNumber, regexUpperCaseLetter } from "src/commun/utils/ValidationsUtils";


const usePasswordCriterias = () => {
  const { tString } = useAppText();

  return [
    {
      displayLabel: tString("password.validator.minuscule"),
      validator: regexLowerCaseLetter
    },
    {
      displayLabel: tString("password.validator.majuscule"),
      validator: regexUpperCaseLetter
    },
    {
      displayLabel: tString("password.validator.chiffre"),
      validator: regexNumber
    },
    {
      displayLabel: tString("password.validator.longueur"),
      validator: regexLength
    }
  ];
};

export default usePasswordCriterias;
